var map = {
	"./Base": 718,
	"./Base/": 718,
	"./Base/index": 718,
	"./Base/index.js": 718,
	"./Base/style": 174,
	"./Base/style.js": 174,
	"./Clutch": 423,
	"./Clutch/": 423,
	"./Clutch/index": 423,
	"./Clutch/index.js": 423,
	"./Clutch/renderComponent": 1621,
	"./Clutch/renderComponent.js": 1621,
	"./Clutch/style": 1280,
	"./Clutch/style.js": 1280,
	"./NewUi": 1001,
	"./NewUi/": 1001,
	"./NewUi/index": 1001,
	"./NewUi/index.js": 1001,
	"./NewUi/style": 1281,
	"./NewUi/style.js": 1281,
	"./OldUi": 1002,
	"./OldUi/": 1002,
	"./OldUi/index": 1002,
	"./OldUi/index.js": 1002,
	"./OldUi/renderComponent": 1622,
	"./OldUi/renderComponent.js": 1622,
	"./OldUi/style": 1282,
	"./OldUi/style.js": 1282,
	"./SpireonNew": 1003,
	"./SpireonNew/": 1003,
	"./SpireonNew/index": 1003,
	"./SpireonNew/index.js": 1003,
	"./SpireonNew/renderComponent": 1623,
	"./SpireonNew/renderComponent.js": 1623,
	"./SpireonNew/style": 1283,
	"./SpireonNew/style.js": 1283,
	"./SpireonOld": 1004,
	"./SpireonOld/": 1004,
	"./SpireonOld/index": 1004,
	"./SpireonOld/index.js": 1004,
	"./SpireonOld/renderComponent": 1624,
	"./SpireonOld/renderComponent.js": 1624,
	"./SpireonOld/style": 1284,
	"./SpireonOld/style.js": 1284
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83;